module.exports = __webpack_public_path__ + "static/media/ipnos-product-features-1.c58027db.png";